module.exports = __webpack_public_path__ + "img/banner-tc2-m.0f5229d6.jpg";